// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — control-plate.classic.js, новая — control-plate.cp.js
import { isCp } from 'libs/design';
import * as classic from './control-plate.classic';
import * as cp from './control-plate.cp';

export const ControlPlate = isCp ? cp.ControlPlate : classic.ControlPlate;
